import React from 'react';

import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';

import SupplierDocumentUpload from '@features/supplier/component/SupplierDocumentUpload';

const AddAssessmentDocuments = ({ onClose, documents }) => {
	const renderDocumentUpload = () => {
		return (
			<SupplierDocumentUpload
				title="Assessment Information"
				fieldName="additionalInformationDocumnetList"
				documents={documents}
				uploadType="SUPPLIER_DOCUMENT"
			/>
		);
	};

	return (
		<ModalContainer className="supplier-doucment-modal assessment-documents-modal">
			<div className="common-popup">
				<ModalHeader title="Assessment Documents" onClose={onClose} />

				<div className="common-popup-body scroll-y-label">
					<div className="container px-0">
						<div className="row">
							<div className="col-md-12">
								<div className="quick-info-files">{renderDocumentUpload()}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default AddAssessmentDocuments;
